import React from 'react'
import { RouteComponentProps } from 'react-router'
import {appModule} from 'services/module'

export default class extends React.Component<RouteComponentProps<any> & IPage> {
	state = {
		currSystemCode: appModule.getCurrentModelingSystem().code,
	}

	render() {
		let systemCode = appModule.getCurrentModelingSystem().code
		return <div></div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/modeling/FunctionPage/FunctionPage.tsx